<template>
  <div
    v-once
    ref="el"
    class="c-px-1 c-mt-4"
  >
    <div class="container static">
      <!-- text -->
      <div class="c-py-4 c-lg:c-py-0 c-lg:c-mb-6 row c-justify-center">
        <div class="c-sm:col-10 text-center static">
          <!-- desktop image -->
          <div
            v-if="!BrowserService.isMobile()"
            :style="{ minHeight: '320px' }"
            class="navbar-secondary__imgbg embed-responsive embed-responsive-16by9 c-m-0"
          >
            <ResponsiveImage
              src="hp-cover.jpg"
              alt="background image"
              :lazy-load="false"
            />
          </div>
          <!-- mobile image -->
          <div
            v-else
            :style="{ minHeight: '560px' }"
            class="navbar-secondary__imgbg embed-responsive embed-responsive-16by9 c-m-0"
          >
            <ResponsiveImage
              src="hp-cover-mobile.jpg"
              alt="background image"
              :lazy-load="false"
            />
          </div>
          <h1 class="c-mb-0 uppercase text-center text-primary-550 relative main-headline hidden c-lg:block">
            <strong class="inline text-green">{{ t('mix') }}</strong>
            <br>
            <template v-if="locale !== 'fr' || locale !== 'it'">
              <span>{{ t('own') }}&nbsp;</span>
              <br class="block c-sm:hidden">
            </template>
            <strong
              id="js-word-change"
              class="animated-word"
              :data-text="t('changing_words')"
            >
              <span>{{ t('muesli') }}</span>
            </strong>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import BrowserService from '@/services/browserService'

import ResponsiveImage from '@/components/general/BaseImage.vue'

const { t, locale } = useI18n()

const el = ref()
const wordChange = ref({})
const textSpan = ref({})
const words = ref([])
const index = ref(0)

const changeWord = () => {
  wordChange.value = el.value.querySelector('#js-word-change')

  textSpan.value = wordChange.value.querySelector('span')
  words.value = wordChange.value.dataset.text.split(',')

  wordChange.value.style.width = textSpan.value.offsetWidth

  setInterval(() => {
    wordChange.value.style.width = '0'

    setTimeout(() => {
      textSpan.value.textContent = words.value[index.value]
      changeWidth()
    }, 500)

    index.value++
    if (index.value >= words.value.length) index.value = 0
  }, 3000)
}

const changeWidth = () => {
  wordChange.value.style.width = `${textSpan.value.offsetWidth}px`
}

onMounted(() => {
  changeWord()
  changeWidth()
})
</script>

<style lang="scss" scoped>
.text-red {
  color: #bf1818;
}
.text-brown {
  color: #4F2B1B;
}
.text-green {
  color: #089234;
}
.animated-word {
	display: inline-flex;
	vertical-align: baseline;
	position: relative;
	overflow: hidden;

	border-right: 2px solid currentColor;
	transition: width 500ms;

	span {
		display: block;
		white-space: nowrap;
		padding-right: map-get($spacers, 2);
	}
}
</style>

<i18n>
  {
    "cs": {
    "changing_words": "müsli,kaše,ovoce,müsli,oříšky,čoko dobroty,müsli,křupavé ovoce,Mixitky,müsli,pytlíky",
    "mix": "Namíchej si",
    "muesli": "müsli",
    "own": "vlastní"
},
    "sk": {
    "changing_words": "müsli,kaše,ovocie,müsli,oriešky,čoko dobroty,müsli,chrumkavé ovocie,Mixitky,müsli,vrecúška",
    "mix": "Namiešaj si",
    "muesli": "müsli",
    "own": "vlastné"
},
    "pl": {
    "changing_words": "musli,kasze,lio owoce,musli,orzeszki,czeko-dobroty,musli,chrupiące owoce,Mixitki,musli,saszetki",
    "mix": "Skomponuj",
    "muesli": "musli",
    "own": "własne"
},
    "hu": {
    "changing_words": "müzlit, kását, gyümölcsöt, müzlit, dióféléket, csokoládét, müzlit, ropogós gyümölcsöt, Mixitkát, müzlit, tasakot",
    "mix": "Mixelj",
    "muesli": "müzli",
    "own": "saját"
},
    "de": {
    "changing_words": "Müsli, Porridge, Müsli, Nüsse, Schoko-Goodies, Müsli, Knusperfrüchte, Mixitriegel, Müsli, Snacktaschen",
    "mix": "Mixe dir",
    "muesli": "Müsli",
    "own": "individuell"
},
    "at": {
    "changing_words": "Müsli, Porridge, Müsli, Nüsse, Schoko-Goodies, Müsli, Knusperfrüchte, Mixitriegel, Müsli, Snacktaschen",
    "mix": "Mixe dir",
    "muesli": "Müsli",
    "own": "individuell"
},
    "ro": {
    "changing_words": "musli, terci, fructe, musli, nuci, ciocolată, musli, fructe crocante, Mixitka, musli, punguțe",
    "mix": "MIXEAZĂ",
    "muesli": "musli",
    "own": "personalizat"
},
    "fr": {
    "changing_words": "muesli, porridge, noix, fruits lyophilisés, chocolat, fruits secs ",
    "mix": "Crée ton mix",
    "muesli": "muesli",
    "own": "personnel"
},
    "it": {
    "changing_words": "muesli, porridge, noci, frutta croccante, cioccolato, frutta secca",
    "mix": "Crea il tuo mix",
    "muesli": "muesli",
    "own": "personalizzato"
}
  }
</i18n>
